import { lazy } from 'react';

export const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
    );
    const buildVersion = import.meta.env.VITE_BUILD_VERSION ?? null;
    const storedVersion = window.localStorage.getItem('app-version') ?? null;

    try {
      // Handle version mismatch safely
      if (buildVersion && (!storedVersion || buildVersion !== storedVersion)) {
        if (!pageHasAlreadyBeenForceRefreshed) {
          window.localStorage.setItem('page-has-been-force-refreshed', 'true');
          window.localStorage.setItem('app-version', buildVersion);

          setTimeout(() => {
            window.location.reload();
          }, 100);

          return new Promise(() => { }); // Prevents React from continuing execution.. thus fixes Unexpected token '<' error
        }
      } else if (!storedVersion && buildVersion) {
        window.localStorage.setItem('app-version', buildVersion);
      }

      const component = await componentImport();

      if (!component || !component.default) {
        throw new Error('Lazy-loaded component does not have a default export.');
      }

      window.localStorage.setItem('page-has-been-force-refreshed', 'false');

      return component;
    } catch (error) {
      console.error('Component loading error:', error);

      throw error;
    }
  });
